import React, { useEffect, useMemo, useState } from "react";
import CountUp from "react-countup";
import { Card, CardBody } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { getPayments } from "common/services/payments.service";
import CardWidgetSkeleton from "Components/Common/CardWidgetSkeleton";
import useQueryState from "Components/Hooks/UseQueryState";
import { getYearDateRange } from "common/lib/dateUtils";
import { Link } from "react-router-dom";

const SalaryScale = () => {
  const [loading, setLoading] = useState(false);
  const [aligningSupport, setAligningSupport] = useState(0);
  const [totalSupport, setTotalSupport] = useState(0);

  const [selectedYear] = useQueryState(
    "year",
    new Date().getFullYear().toString()
  );
  const { firstDay, lastDay } = getYearDateRange(selectedYear);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Simulate fetching data
        const response: any = await getPayments({
          filters: {
            isSalaryAligned: true,
            $or: [
              {
                startDate: {
                  $between: [firstDay, lastDay],
                },
              },
              {
                endDate: {
                  $between: [firstDay, lastDay],
                },
              },
            ],
          },
        });
        setAligningSupport(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        // Simulate fetching data
        const response: any = await getPayments({
          filters: {
            $or: [
              {
                startDate: {
                  $between: [firstDay, lastDay],
                },
              },
              {
                endDate: {
                  $between: [firstDay, lastDay],
                },
              },
            ],
          },
        });
        setTotalSupport(response?.meta?.pagination?.total || 0);
      } catch (error) {
        console.warn("Error fetching aligning support", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [firstDay, lastDay]);

  const percentageValue = useMemo(() => {
    if (totalSupport === 0) return 0;
    return (aligningSupport / totalSupport) * 100;
  }, [aligningSupport, totalSupport]);

  if (loading) {
    return <CardWidgetSkeleton />;
  }

  return (
    <Link to={"/payments"}>
      <Card className="card-animate card-bottom-primary">
        <CardBody>
          <div className="d-flex justify-content-between">
            <div>
              <p className="fw-medium text-muted mb-0">
                Aligning with Salary Scale
              </p>
              <h2 className="mt-4 ff-secondary cfs-22 fw-semibold">
                <span className="counter-value" data-target={aligningSupport}>
                  <CountUp
                    start={0}
                    end={aligningSupport}
                    decimals={0}
                    duration={1}
                  />
                </span>
              </h2>
              <p className="mb-0 text-muted text-truncate">
                <span className="badge bg-light text-danger mb-0">
                  {/* <i className="ri-arrow-down-line align-middle"></i> */}
                  {percentageValue.toFixed(2)} %
                </span>{" "}
                of total support
              </p>
            </div>
            <div>
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-info-subtle rounded-circle fs-2">
                  <FeatherIcon icon="check-square" className="text-success" />
                </span>
              </div>
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
};

export default SalaryScale;
